var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"estaciones"},[_c('map-overlay',{attrs:{"type":"estaciones"}}),_c('footer',{staticClass:"estaciones__bar"},[_c('desktop-footer',{staticClass:"estaciones__bar__desktop-footer"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }